import { useContext, useEffect } from 'react';
import { Stack } from '@mantine/core';
import BookitupAddIcon from '../../../../Atoms/BookitupAddIcon';
import SkeletonItems from '../../../../Atoms/SkeletonItems';
import PanePaper from '../../../../Molecules/PanePaper';
import { RoutingS } from '../../../../Service/RoutingS';
import EmptyText from '../../../../Atoms/EmptyText';
import { useAgencyTemplates } from '../../../../Service/hooks/useAgencyTemplates';
import { ViolationContext } from '../../../../Service/Context/ViolationContext';
import { LicenceS } from '../../../../Service/LicenceS';
import TemplateListItem from './TemplateListItem';
import { openCreateTemplateModal } from './AgencyTemplateModals';

const AgencyTemplatesSection = () => {
  const { templates, loading, handlers, isEmpty, handleChange } = useAgencyTemplates();
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const { remove } = handlers;

  useEffect(() => {
    RoutingS.changeTitle('Agenturvorlagen');
  }, []);

  const onCreateHandler = () => {
    const existingNames = templates.map((t) => t.name);
    openCreateTemplateModal({ existingNames });
  };

  return (
    <PanePaper
      title="Agenturvorlagen"
      tooltip="help.settings.message.agency.templates.pane"
      rightSection={
        <BookitupAddIcon
          onClick={() => executeWithLicenceCheck(LicenceS.Restrictions.AGENCY_TEMPLATES, onCreateHandler)}
        />
      }
      sx={{ maxWidth: 500 }}
    >
      <Stack mt={isEmpty ? 0 : 'md'}>
        {loading && <SkeletonItems count={8} height={80} />}
        {isEmpty && <EmptyText />}
        {!loading &&
          templates.map((template, index) => (
            <TemplateListItem
              key={template.id}
              template={template}
              onDelete={() => remove(index)}
              onUpdate={(patch) => handleChange(template.id, patch)}
            />
          ))}
      </Stack>
    </PanePaper>
  );
};

export default AgencyTemplatesSection;
